import { OrganizationRole } from '@neptune/shared/core-organizations-domain';

export const availableOrganizationRoles: OrganizationRole[] = [
  OrganizationRole.owner,
  OrganizationRole.member,
];
